import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import BannerPage from '../../../components/BannerPage';
import Footer from '../../../components/Footer';
import '../../../App.css';
import ruesData from '../../../data/rues.json';

const Tonneliers = () => {
  const navigate = useNavigate();
  
  const handlePageClick = (link) => {
    navigate(link);
  };

  // Filtrer le tableau ruesData pour récupérer uniquement l'élément correspondant à "Bert"
  const saubiolePage = ruesData.find((page) => page.name === "Saubiole");
  const trinquetPage = ruesData.find((page) => page.name === "Trinquet");

  return (
    <div>
      <BannerPage>
        <div>
          <h2>Tonneliers</h2>
          <h3>Histoire et photos des rues, monuments et ponts du petit Bayonne</h3>
        </div>
      </BannerPage>
      <div className="riverain-container">
        <div className="image-container2">
          <img src="https://petitbayonne18852000.files.wordpress.com/2022/11/rue-des-tonneleirs-les-arceaux.jpg" alt="Les Tonneliers - Les Arceaux" className="riverain-image" />
          <figcaption>Les Tonneliers - Les Arceaux</figcaption>
        </div>
        <div className='apropos-content'>
          <h4>Rue des TONNELIERS</h4>
          <p className='histoire'>
          Changement de numérotation en 1855.<br /> <br />
          Les tonneliers, qui étaient au départ à la rue Doer ou Douer (qui signifie tonneau) ont gagné la rive droite de la Nive et la rue des Tonneliers au 15ème siècle.<br />   <br />
          </p>
        </div>
      </div>
      <div className="navigation-buttons">
        {/* Afficher le bouton seulement si l'élément correspondant existe */}
        {saubiolePage && trinquetPage && (
          <div className="riverain-buttons">
            <div className="riverain-item" onClick={() => handlePageClick(saubiolePage.link)}>
              <Link to={saubiolePage.link}>Page précédente</Link>
            </div>
            <div className="riverain-item" onClick={() => handlePageClick(trinquetPage.link)}>
              <Link to={trinquetPage.link}>Page suivante</Link>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Tonneliers;